module.exports = __webpack_public_path__ + "img/shuilian2.4d660571.gif";